
import React, { useState, useEffect } from "react";
import api from "../../api/api";
import ExcelExport from "../../UserControls/ExcelExport/ExcelExport";

const Maintenance = ({ User, ServiceId }) => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    ServiceDate: "",
    CommentBy: User || "",
    Solution: "",
  });
  const [maintenanceList, setMaintenanceList] = useState([]);

  useEffect(() => {
    if (ServiceId) fetchMaintenanceList();
  }, [ServiceId]);

  const fetchMaintenanceList = async () => {
    try {
      const response = await api.EditServicesparelistAPI(ServiceId);
      const table = response?.data?.Table1 || response?.Table1 || [];
      setMaintenanceList(table);
    } catch (error) {
      console.error("Error fetching maintenance list:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!formData.ServiceDate || !formData.Solution) {
      alert("Please fill in Service Date and Solution.");
      return;
    }
    const datePart = formData.ServiceDate; 
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
    const timePart = `${hours}:${minutes}:${seconds}.${milliseconds}`;
    const fullServiceDate = `${datePart} ${timePart}`;
    const payload = {
      ServiceId,
      ServiceDate: fullServiceDate,
      CommentById: User?.Id || "0",
      CommentBy: formData.CommentBy,
      Solution: formData.Solution,
      Number: "1",
    };

    try {
      await api.SaveServiceMaintanceAPI(payload);
      await fetchMaintenanceList(); 
      setShowModal(false);
      setFormData({ ServiceDate: "", CommentBy: User, Solution: "" });
    } catch (error) {
      console.error("Error saving maintenance action:", error);
      alert("Failed to save record.");
    }
  };

  const handleDelete = async (solutionId) => {
  if (!window.confirm("Are you sure you want to delete this maintenance action?")) return;

  try {
    await api.DeleteServiceMaintanceAPI(ServiceId, solutionId);

    await fetchMaintenanceList();
  } catch (error) {
    console.error("Error deleting maintenance action:", error);
    alert("Failed to delete record.");
  }
};


  // ✅ Modified function to initialize modal with current date
  const handleAddNew = () => {
    const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
    setFormData({
      ServiceDate: today,
      CommentBy: User || "",
      Solution: "",
    });
    setShowModal(true);
  };

  return (
    <div className="maintenance-container">
      <div className="header">
        <button className="btn-primary" onClick={handleAddNew}>+ Add</button>
         <ExcelExport data={maintenanceList} fileName="Maintenance" />
        <h3>Future Maintenance Actions</h3>
        
      </div>

      {maintenanceList.length === 0 ? (
        <div className="placeholder-tab">No maintenance actions found.</div>
      ) : (
        <table className="maintenance-table">
          <thead>
            <tr>
              <th>SlNo</th>
              <th>Service Date</th>
              <th>Comment By</th>
              <th>Solution</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {maintenanceList.map((item, index) => (
              <tr key={Number(item.SolutionId)}>
                <td>{index + 1}</td>
                <td>{item.ServiceDate?.substring(0, 10)}</td>
                <td>{item.CommentBy}</td>
                <td>{item.Solution}</td>
                <td>
                  <button className="btn-danger" onClick={() => handleDelete(Number(item.SolutionId))}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-container">
            <h3>Add Future Maintenance</h3>
            <div className="form-group-column">
              <label>Service Date</label>
              <input type="date" name="ServiceDate" value={formData.ServiceDate} onChange={handleChange} />

              <label>Comment By</label>
              <input type="text" name="CommentBy" value={formData.CommentBy} readOnly />

              <label>Solution</label>
              <textarea name="Solution" value={formData.Solution} onChange={handleChange}></textarea>

              <div className="modal-actions">
                <button className="btn-primary" onClick={handleSave}>Save</button>
                <button className="btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Styles */}
      <style jsx>{`
        .maintenance-container {
          max-width: 900px;
          margin: 20px auto;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
        }

        h3 {
          margin: 0;
          color: #333;
        }

        .btn-primary {
          background-color: #007bff;
          color: white;
          padding: 8px 15px;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          font-weight: 500;
        }

        .btn-primary:hover {
          background-color: #196ad4ff;
        }

        .btn-secondary {
          background-color: #ccc;
          color: #333;
          padding: 8px 15px;
          border: none;
          border-radius: 5px;
          cursor: pointer;
        }

        .btn-secondary:hover {
          background-color: #b3b3b3;
        }

        .btn-danger {
          background-color: #f44336;
          color: white;
          padding: 5px 10px;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          font-size: 0.9rem;
        }

        .btn-danger:hover {
          background-color: #da190b;
        }

        .placeholder-tab {
          text-align: center;
          color: #888;
          padding: 20px;
          font-style: italic;
        }

        .maintenance-table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 20px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }

        .maintenance-table th, .maintenance-table td {
          padding: 10px 15px;
          border-bottom: 1px solid #ddd;
          text-align: left;
        }

        .maintenance-table th {
          background-color: #f4f4f4;
          color: #555;
        }

        .maintenance-table tr:hover {
          background-color: #f9f9f9;
        }

       .modal-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.5);
          /* *** REMOVED display: flex, justify-content, align-items *** */
          z-index: 1000;
        }

        .modal-container {
          background: white;
          padding: 25px 30px;
          border-radius: 10px;
          width: 450px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.2);
          
          /* *** NEW Centering Logic using Absolute Position and Transform *** */
          position: absolute; /* Relative to the fixed overlay */
          top: 50%;         /* Move down 50% from the top */
          left: 50%;        /* Move right 50% from the left */
          transform: translate(-50%, -50%); /* Move back by half of its own width/height */
          /* *************************************************************** */
        }

        .modal-container h3 {
          margin-top: 0;
          border-bottom: 1px solid #eee;
          padding-bottom: 8px;
          color: #333;
        }

        .form-group-column {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-top: 15px;
        }

        .form-group-column label {
          font-weight: 500;
          color: #555;
        }

        .form-group-column input,
        .form-group-column textarea {
          padding: 8px 10px;
          border-radius: 5px;
          border: 1px solid #ccc;
          font-size: 0.95rem;
          width: 100%;
          box-sizing: border-box;
        }

        .form-group-column textarea {
          resize: vertical;
          min-height: 60px;
        }

        .modal-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          margin-top: 15px;
        }
      `}</style>
    </div>
  );
};

export default Maintenance;

